import { supplyChainHostWarehouse } from '../util/env';

export const ApiUrl = {
    userMenu: '/admin/userMenu',
    orgList: `${supplyChainHostWarehouse}/admin/organization/list`,
    orgQuery: `${supplyChainHostWarehouse}/admin/organization/query`,
    orgSave: `${supplyChainHostWarehouse}/admin/organization/save`,
    menuNew: `/admin/homeCenter`,
    outerLink: `/admin/homeCenter/getLink`,
    checkAuth: `/admin/homeCenter/checkAuth`,
}

export default ApiUrl;